import { ready } from '@util/global';

import { initLayout } from '@util/layout';

ready(() => {
  initLayout();
});
